'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const GapChartInner = dynamic(() => import('./GapChartInner'), { ssr: false });

export default function GapChartPanel() {
  return (
    <div className="card-forge rounded-xl p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="text-forge-label">Trend vs Target Trajectory</div>
        <div className="flex items-center gap-4 text-2xs">
          <span className="flex items-center gap-1.5">
            <span className="w-3 h-0.5 bg-primary inline-block rounded" />
            Trend Weight
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-3 h-0.5 inline-block rounded" style={{ backgroundColor: 'var(--accent)' }} />
            Target Path
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-3 h-0.5 border-t border-dashed border-muted-foreground inline-block" />
            Actual
          </span>
        </div>
      </div>
      <GapChartInner />
    </div>
  );
}